/**
 * Minimal className combiner: joins truthy class fragments. Kept dependency-free
 * (no clsx/tailwind-merge) — good enough for the shell and avoids extra deps.
 */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
